import {
  Card,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Button,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { useState } from "react";

import Help from "~/components/common/Help";
import CancellationReasonRow, { CancellationReasonDialog } from "./CancellationReasonRow";
import { sortBy } from "lodash";

const TabCancellationReasons = () => {
  const { visitCancellationReasons, loading } = useOrgConfig();
  
  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const cancellationReasons = sortBy(Object.values(visitCancellationReasons), "description");

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card sx={{ height: "100%" }}>
        <TableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '70%', maxWidth: '500px' }}>
                  Cancellation Reason
                  <Help text="Reason that can be selected when canceling a visit." />
                </TableCell>
                <TableCell sx={{ width: '15%', maxWidth: '120px' }}>Status</TableCell>
                <TableCell sx={{ width: '15%', maxWidth: '100px' }}>Active</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <>
                  <RowSkeleton />
                  <RowSkeleton />
                  <RowSkeleton />
                </>
              ) : cancellationReasons.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} sx={{ textAlign: "center" }}>
                    No cancellation reasons found
                  </TableCell>
                </TableRow>
              ) : (
                cancellationReasons.map((reason) => (reason && <CancellationReasonRow key={reason.id} reason={reason} />))
              )}
            <TableRow>
              <TableCell colSpan={2}>
                <Button
                  onClick={() => setCreateDialogOpen(true)}
                  size="small"
                  startIcon={<AddCircleOutlineIcon fontSize="small" />}
                >
                  Add New Cancellation Reason
                </Button>
              </TableCell>
            </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {createDialogOpen && <CancellationReasonDialog
        reason={{ description: "", active: true, id: 0 }}
        onClose={() => setCreateDialogOpen(false)}
      />}
    </Container>
  );
};

export default TabCancellationReasons;

const RowSkeleton = () => (
  <TableRow>
    <TableCell sx={{ width: '70%', maxWidth: '500px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '15%', maxWidth: '120px' }}>
      <Skeleton width="100%" />
    </TableCell>
    <TableCell sx={{ width: '15%', maxWidth: '100px' }}>
      <Skeleton width="100%" />
    </TableCell>
  </TableRow>
);
